import { useState } from 'react';
import { EyeClosedIcon } from '../icons/react/eye-closed.tsx';
import { EyeIcon } from '../icons/react/eye.tsx';
import { InputIconButton } from './input-icon-button.tsx';
import { Input, InputProps } from './input.tsx';

export const PasswordInput = function PasswordInputComponent({
  ref,
  onChange,
  ...props
}: InputProps) {
  const [passwordShown, setPasswordShown] = useState(false);
  const [showEye, setShowEye] = useState(!!props.value || !!props.defaultValue);

  return (
    <Input
      ref={ref}
      {...props}
      type={passwordShown ? 'text' : 'password'}
      onChange={(e) => {
        setShowEye(e.target.value.length > 0);
        onChange?.(e);
      }}
      after={
        showEye ? (
          <InputIconButton
            onClick={(e) => {
              e.preventDefault();
              setPasswordShown((prev) => !prev);
            }}
          >
            {passwordShown ? <EyeClosedIcon /> : <EyeIcon />}
          </InputIconButton>
        ) : null
      }
    />
  );
};
